import styled, { css } from 'styled-components'

import { mobileMediaQuery } from '@subaio/webapp'

export const Grid = styled.div`
	display: grid;
	grid-template-columns: 600px 1fr;
	height: 100vh;

	${mobileMediaQuery(css`
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	`)}
`
